import { render, staticRenderFns } from "./DrawerNew.vue?vue&type=template&id=cce5c174&"
import script from "./DrawerNew.vue?vue&type=script&lang=js&"
export * from "./DrawerNew.vue?vue&type=script&lang=js&"
import style0 from "./DrawerNew.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./DrawerNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VDivider,VImg,VList,VNavigationDrawer})
